import React, { useEffect } from 'react';
import { Button } from '../components/ui/button';
import { useNavigate, useLocation } from 'react-router-dom';
import { FileQuestion, Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Optional: Log the 404 attempt for analytics
        console.warn(`404 Page Not Found: ${location.pathname}`);
    }, [location]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
            <div className="max-w-md w-full text-center space-y-6">

                {/* Animated Icon */}
                <div className="relative w-24 h-24 mx-auto">
                    <div className="absolute inset-0 bg-blue-100 rounded-full animate-ping opacity-25"></div>
                    <div className="relative z-10 w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center text-blue-500">
                        <FileQuestion size={48} strokeWidth={1.5} />
                    </div>
                </div>

                <div className="space-y-2">
                    <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight">
                        Page Not Found
                    </h1>
                    <p className="text-lg text-gray-500">
                        The page you are looking for doesn't exist or has been moved.
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
                    <Button
                        variant="outline"
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2"
                    >
                        <ArrowLeft size={16} />
                        Go Back
                    </Button>
                    <Button
                        onClick={() => navigate('/dashboard')}
                        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white shadow-lg shadow-blue-200"
                    >
                        <Home size={16} />
                        Return Home
                    </Button>
                </div>

                <div className="pt-8 border-t border-gray-200 mt-8">
                    <p className="text-xs text-gray-400">
                        Error Code: 404 • FinAssure Security
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
